import { render, staticRenderFns } from "./resourceCourseAdministrator.vue?vue&type=template&id=e598a17e"
import script from "./resourceCourseAdministrator.vue?vue&type=script&lang=js"
export * from "./resourceCourseAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports